function IconAntifraudeReprovada(props) {
  return (
    <svg 
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 25 25"
    width={props.width ? props.width : '25'}
    height={props.height ? props.height : '25'}
    fill="none"
    style={{ paddingRight: props.paddingRight }}
    >
      <path 
        fill={props.color ? props.color : '#FF4C51'}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12z"
      />
    </svg>

  );
}

export default IconAntifraudeReprovada;
